import React from "react"
import { AppDispatch } from "../../../reduxStore/store"
import {
  ErrorState,
  selectErrorHandler,
  initialState as initialWarningState,
  errorHandlerUpdated,
} from "../errorSlice"
import { useDispatch, useSelector } from "react-redux"
import { Banner } from "../../shared/components/Banner"

/**
 * @deprecated Use BannerWithId and bannersWithId state instead. This component uses the legacy warningBanner state.
 */
export const WarningBanner: React.FC = () => {
  const dispatch: AppDispatch = useDispatch()

  const errorState: ErrorState = useSelector(selectErrorHandler)

  const warningBannerState = errorState.warningBanner

  const handleOnBannerClose = () => {
    const payload: Partial<ErrorState> = {
      warningBanner: initialWarningState.warningBanner,
    }
    dispatch(errorHandlerUpdated(payload))

    warningBannerState.onClose?.()
  }

  return (
    <Banner
      type="warning"
      title={warningBannerState.title}
      content={warningBannerState.content}
      isOpen={warningBannerState.isVisible}
      onClose={handleOnBannerClose}
      id="profile-card"
      sticky={true}
      styleOverrides={`z-10`}
      contentStyleOverrides="text-base"
      titleStyleOverrides="text-base"
    />
  )
}

export default WarningBanner
